module.exports = __webpack_public_path__ + "img/BG@3x@2x.b933053e.png";